import { render, staticRenderFns } from "./edit_account_link.vue?vue&type=template&id=c5d4b796&"
import script from "./edit_account_link.vue?vue&type=script&lang=js&"
export * from "./edit_account_link.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports